import React, { useEffect, useRef, FC } from 'react'
import { Button, Card, Checkbox, Col, Form, Icon, Input, message, Row } from 'antd'
import { WrappedFormUtils } from 'antd/lib/form/Form'
import H from 'history'
import logo from '../../assets/Logo.png'
import styles from './index.module.less'

interface LoginProps {
	defaultPage: string
	form: WrappedFormUtils
	location: H.Location<{ intended: string }>
	history: H.History
}

const Login: FC<LoginProps> = ({ form, location, history, defaultPage }) => {
	const handleSubmit = (): void => {
		form.validateFields(async err => {
			if (err) {
				return
			}
			try {
				history.replace(!location.state ? defaultPage : location.state.intended)
			} catch (error) {
				message.error(error.message)
			}
		})
	}

	const { getFieldDecorator } = form

	const input = useRef(null)
	useEffect(() => input.current.focus(), [])

	return (
		<Row type='flex' align='middle' className={styles.login}>
			<img alt='The Mondago Logo' src={logo} className={styles.logo} />
			<Col xs={24} sm={16} md={12} lg={10} xl={8} xxl={6}>
				<Card>
					<Form>
						<Form.Item>
							{getFieldDecorator('username', {
								rules: [
									{
										whitespace: true,
										required: true,
										message: 'Please enter your username.'
									}
								]
							})(
								<Input
									ref={input}
									onPressEnter={handleSubmit}
									prefix={<Icon type='user' className={styles.icon} />}
									placeholder='Username'
									autoComplete='username'
								/>
							)}
						</Form.Item>
						<Form.Item>
							{getFieldDecorator('password', {
								rules: [
									{
										required: true,
										message: 'Please enter your password.'
									}
								]
							})(
								<Input.Password
									onPressEnter={handleSubmit}
									prefix={<Icon type='lock' className={styles.icon} />}
									placeholder='Password'
									autoComplete='current-password'
								/>
							)}
						</Form.Item>

						<Form.Item>
							{getFieldDecorator('remember', {
								initialValue: true,
								valuePropName: 'checked'
							})(<Checkbox>Remember me</Checkbox>)}
						</Form.Item>
						<Row className={styles.buttons}>
							<Button onClick={handleSubmit} type='primary'>
								Login
							</Button>
							<Button type='link'>Forgot password?</Button>
						</Row>
					</Form>
				</Card>
			</Col>
			<Col xs={24} sm={16} md={12} lg={10} xl={8} xxl={6}>
				<span className={styles.notice}>
					By logging in to this portal you are agreeing to comply with the following{' '}
					<a href='https://mondago.com/policies/?terms-and-conditions' target='_blank' rel='noopener noreferrer'>
						terms & conditions
					</a>{' '}
					and{' '}
					<a href='https://mondago.com/policies/?privacy-policy' target='_blank' rel='noopener noreferrer'>
						privacy policy
					</a>
				</span>
			</Col>
		</Row>
	)
}

export default Form.create<LoginProps>()(Login)
